"use client";

import Image from "next/image";
import { Button } from "@excelia-io/ui-lib";
import { config } from "config";
import { useEffect, useState } from "react";
import apiClient from "api";
import { Loader } from "components";

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const currentYear = new Date().getFullYear();
  const handleLogin = () => {
    const redirectUrl = `${config.paymentsUrl}/create-payment-method`;
    const loginUrl = `${config.apiBaseUrl}/auth/login?redirect_url=${encodeURIComponent(redirectUrl)}`;
    console.log(loginUrl,"login url")
    window.location.href = loginUrl;
  };

  const handleSignup = () => {
     const redirectUrl = `${config.paymentsUrl}/create-payment-method`;
    const loginUrl = `${config.apiBaseUrl}/auth/login?redirect_url=${encodeURIComponent(redirectUrl)}`;
    // const redirectUrl = `${config.paymentsUrl}/`;//loginurl from abovve
    const signupUrl = `${config.apiBaseUrl}/auth/signup?redirect_url=${encodeURIComponent(loginUrl)}`;
    window.location.href = signupUrl;
  };


  const fetchUserInfo = async () => {
    try {
      setIsLoading(true);
      const result = await apiClient.get("/entities/users/me", {
        withCredentials: true,
      });
      if (result?.data?.id) {
        handleLogin();
      }
    } catch (error) {
      console.error(error, "ERROR");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <header className="relative bg-primary text-white overflow-hidden h-52">
        <div className="absolute top-0 right-0 w-64 h-64 pointer-events-none">
          <Image
            src="/logo-diamond.svg"
            alt="Diamond Pattern"
            width={256}
            height={256}
          />
        </div>

        {/* Header Navigation */}
        <div className="flex items-start justify-between px-8 pt-4 relative z-10">
          <div className="flex items-center gap-3">
            <Image
              src="/logo.svg"
              alt="Excelia Logo"
              width={300}
              height={300}
            />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-white pt-16 pb-4">
        <div className="w-full px-8 text-center">
          <h1 className="text-4xl font-bold text-gray-800">
           You're Almost There!
          </h1>
          <p className="text-gray-600 mt-2">
           Log In or Sign Up to review your order and finish your purchase.
          </p>
        </div>
      </section>

      {/* Login/Signup Section */}
      <section className="flex-1 bg-white flex flex-col items-center justify-start pt-16 pb-12">
        <div className="w-full px-8 max-w-5xl flex flex-col items-center gap-6">
          <div className="flex gap-4 justify-center">
            <Button
              onClick={handleLogin}
              className="px-8 py-3 cursor-pointer rounded-none"
              style={{ backgroundColor: "#1A5667" }}
              size="lg"
            >
              Log In
            </Button>
            <Button
              onClick={handleSignup}
              className="px-8 py-3 cursor-pointer rounded-none"
              style={{ backgroundColor: "#1A5667" }}
              size="lg"
            >
              Sign Up
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-8">
        <div className="max-w-7xl mx-auto px-8 text-center text-sm text-gray-700">
          <p className="mb-1">
            Need support? Email us at{" "}
            <a
              href="mailto:support@myexcelia.com"
              className="font-semibold text-gray-900"
            >
              support@myexcelia.com
            </a>
          </p>
          <p>© Copyright {currentYear} Excelia. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
